"use client";

import { useEffect, useState } from "react";
import { Heading } from "./heading";
import { Subheading } from "./subheading";
import { AnimatePresence, motion } from "framer-motion";
import { PlatformIcon } from "@/utils/platform-icons";
export const Companies = () => {
  const headingVariations = [{
    heading: "Ready-to-use templates for launch platforms",
    subheading: "Launch systematically across 100+ curated platforms where successful startups get their first customers"
  }];

  // Use useState to keep the selected variation consistent during render
  const [selectedVariation] = useState(() => headingVariations[Math.floor(Math.random() * headingVariations.length)]);
  let [logos, setLogos] = useState([[{
    title: "Product Hunt",
    platform: "producthunt"
  }, {
    title: "Twitter/X",
    platform: "twitter"
  }, {
    title: "Reddit",
    platform: "reddit"
  }, {
    title: "LinkedIn",
    platform: "linkedin"
  }, {
    title: "Facebook",
    platform: "facebook"
  }], [{
    title: "IndieHackers",
    platform: "indiehackers"
  }, {
    title: "MicroLaunch",
    platform: "microlaunch"
  }, {
    title: "Discord Communities",
    platform: "discord"
  }, {
    title: "YouTube",
    platform: "youtube"
  }, {
    title: "Instagram",
    platform: "instagram"
  }]]);
  const [activeLogoSet, setActiveLogoSet] = useState(logos[0]);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const flipLogos = () => {
    setLogos(currentLogos => {
      const newLogos = [...currentLogos.slice(1), currentLogos[0]];
      setActiveLogoSet(newLogos[0]);
      setIsAnimating(true);
      return newLogos;
    });
  };
  useEffect(() => {
    if (!isAnimating) {
      const timer = setTimeout(() => {
        flipLogos();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isAnimating]);
  return <div className=" flex w-screen flex-col items-center justify-center py-32 text-white dark:text-white md:pb-40 md:pt-20" data-sentry-component="Companies" data-sentry-source-file="companies.tsx">
      <div className="relative z-20 ">
        <Heading as="h2" data-sentry-element="Heading" data-sentry-source-file="companies.tsx">{selectedVariation.heading}</Heading>

        <div className="relative mt-20 flex h-full w-full flex-wrap justify-center gap-10 md:gap-40">
          <AnimatePresence mode="popLayout" onExitComplete={() => setIsAnimating(false)} data-sentry-element="AnimatePresence" data-sentry-source-file="companies.tsx">
            {activeLogoSet.map((logo, idx) => <motion.div initial={{
            y: 40,
            opacity: 0,
            filter: "blur(10px)"
          }} animate={{
            y: 0,
            opacity: 1,
            filter: "blur(0px)"
          }} exit={{
            y: -40,
            opacity: 0,
            filter: "blur(10px)"
          }} transition={{
            duration: 0.8,
            delay: 0.1 * idx,
            ease: [0.4, 0, 0.2, 1]
          }} key={logo.title} className={`group relative ${idx === 4 ? "hidden xl:block" : ""}`}>
                <PlatformIcon platform={logo.platform} customSize={{
              container: "h-14 w-14",
              icon: "h-14 w-14",
              dimensions: 64
            }} plainContainer={true} animated={false} />
                {/* <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs text-muted-foreground opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {logo.title}
                 </span> */}
              </motion.div>)}
          </AnimatePresence>
        </div>
      </div>
    </div>;
};